<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="politica-cookies">

        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-6">POLÍTICA DE GALETES</h1>

                <h2>Què són les galetes?</h2>
                <p>
                  Una galeta (cookie) és un petit arxiu de text que un lloc web emmagatzema al
                  navegador de l'usuari quan el visita. Les galetes permeten que el web recordi
                  informació sobre la visita, com l'idioma preferit o altres opcions, amb la
                  finalitat de facilitar la navegació i fer-la més útil.
                </p>

                <h2>Qui és el responsable del tractament?</h2>
                <p>
                  El responsable de l'ús de galetes d'aquest lloc web és
                  <strong>GESTORIA RIOLA, S.L.</strong>, amb CIF B43785096 i domicili a la
                  Rambla Nova núm. 110, 2n 2a, 43001 Tarragona. Pots contactar amb nosaltres a
                  <a href="mailto:riola@gestoriariola.com">riola@gestoriariola.com</a>.
                </p>

                <h2>Quins tipus de galetes utilitza aquest web?</h2>

                <h3>1. Galetes tècniques o necessàries</h3>
                <p>
                  Són imprescindibles per al correcte funcionament del lloc web i no es poden
                  desactivar. Permeten la navegació per la pàgina, l'ús de les seves funcions i
                  recordar les teves preferències, com l'estat d'acceptació d'aquesta política
                  de galetes. No requereixen consentiment i no emmagatzemen informació amb
                  finalitats publicitàries.
                </p>

                <h3>2. Galetes d'anàlisi o mesurament</h3>
                <p>
                  Ens permeten conèixer com interactuen els usuaris amb el web (pàgines més
                  visitades, temps de navegació, en quin punt s'abandona un formulari) amb la
                  finalitat de millorar els nostres serveis. <strong>Aquestes galetes no
                  s'instal·len i els scripts que les generen no es descarreguen fins que
                  n'acceptes l'ús al bàner de galetes.</strong> Si no acceptes, el teu navegador
                  no arriba a connectar-se amb aquests proveïdors.
                </p>
                <p>Els serveis que utilitzem són:</p>
                <ul>
                  <li>
                    <strong>Google Analytics 4</strong> (Google Ireland Limited): estadístiques
                    d'ús agregades. L'adreça IP es trunca i no s'utilitza per identificar-te.
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Política de privacitat de Google</a>.
                  </li>
                  <li>
                    <strong>Microsoft Clarity</strong> (Microsoft Corporation): mapes de calor i
                    enregistrament de la sessió de navegació, per veure on s'encallen els
                    usuaris. Està configurat per amagar automàticament el contingut dels camps
                    dels formularis, de manera que les dades que hi escriguis <em>no</em> queden
                    registrades.
                    <a href="https://privacy.microsoft.com/ca-es/privacystatement" target="_blank" rel="noopener">Declaració de privacitat de Microsoft</a>.
                  </li>
                </ul>

                <h3>3. Galetes de tercers</h3>
                <p>
                  Determinades funcions del web es recolzen en serveis de tercers (per exemple,
                  l'enviament de formularis de contacte o de sol·licitud de pressupost). Aquests
                  proveïdors poden instal·lar les seves pròpies galetes de caràcter tècnic per
                  gestionar l'enviament de la informació. En cap cas utilitzem galetes de
                  publicitat comportamental.
                </p>

                <h2>Relació de galetes</h2>
                <v-simple-table dense class="mb-6">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Galeta</th>
                        <th class="text-left">Proveïdor</th>
                        <th class="text-left">Finalitat</th>
                        <th class="text-left">Durada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>gr-cookie-consent</td>
                        <td>Gestoria Riola</td>
                        <td>Desa si has acceptat o rebutjat les galetes (no és una galeta: es desa a l'emmagatzematge local del navegador)</td>
                        <td>Fins que esborris les dades del navegador</td>
                      </tr>
                      <tr>
                        <td>_ga, _ga_*</td>
                        <td>Google Analytics 4</td>
                        <td>Distingir usuaris i sessions per a les estadístiques d'ús</td>
                        <td>2 anys</td>
                      </tr>
                      <tr>
                        <td>_clck</td>
                        <td>Microsoft Clarity</td>
                        <td>Identificador d'usuari per a aquest web</td>
                        <td>1 any</td>
                      </tr>
                      <tr>
                        <td>_clsk</td>
                        <td>Microsoft Clarity</td>
                        <td>Uneix les pàgines vistes en una mateixa sessió</td>
                        <td>1 dia</td>
                      </tr>
                      <tr>
                        <td>CLID, MUID, ANONCHK, MR, SM</td>
                        <td>Microsoft (clarity.ms)</td>
                        <td>Galetes de tercers del mateix servei de Microsoft</td>
                        <td>Establerta i gestionada per Microsoft</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <h2>Transferències internacionals de dades</h2>
                <p>
                  Google i Microsoft poden tractar les dades recollides per aquestes galetes en
                  servidors situats fora de l'Espai Econòmic Europeu, inclosos els Estats Units.
                  Tots dos proveïdors estan adherits al
                  <a href="https://www.dataprivacyframework.gov/" target="_blank" rel="noopener">EU-U.S. Data Privacy Framework</a>
                  i apliquen clàusules contractuals tipus aprovades per la Comissió Europea. Si
                  no acceptes les galetes d'anàlisi, cap dada teva no es transfereix a aquests
                  proveïdors.
                </p>

                <h2>Com pots gestionar o desactivar les galetes?</h2>
                <p>
                  En la teva primera visita mostrem un bàner des del qual pots
                  <strong>acceptar</strong> o <strong>rebutjar</strong> l'ús de galetes no
                  necessàries. Pots canviar d'opinió en qualsevol moment i amb la mateixa
                  facilitat amb què el vas donar: prem el botó següent i et tornarem a
                  preguntar. En retirar el consentiment s'esborren les galetes d'anàlisi que ja
                  estiguessin instal·lades.
                </p>
                <p class="mb-6">
                  <v-btn depressed dark color="#900A30" @click="volverAPreguntar">
                    Canviar la meva decisió sobre les galetes
                  </v-btn>
                </p>
                <p>
                  A més, pots permetre, bloquejar o eliminar les galetes instal·lades al teu
                  equip configurant les opcions del teu navegador:
                </p>
                <ul>
                  <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">Google Chrome</a></li>
                  <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener">Mozilla Firefox</a></li>
                  <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener">Safari</a></li>
                  <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noopener">Microsoft Edge</a></li>
                </ul>
                <br>
                <p>
                  Tingues en compte que si desactives les galetes tècniques és possible que
                  algunes funcions del lloc web no estiguin disponibles o no funcionin
                  correctament.
                </p>

                <h2>Actualització de la política de galetes</h2>
                <p>
                  Aquesta política de galetes es pot modificar en funció de noves exigències
                  legals o canvis en el funcionament del lloc web. Et recomanem revisar-la
                  periòdicament. Per a més informació sobre el tractament de les teves dades
                  personals, consulta el nostre
                  <a href="/aviso-legal-cat">Avís legal i Política de privacitat</a>.
                </p>
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import consentimiento from '@/plugins/consentimiento';
  import MenuTop from "@/components/MenuTopCat";
  import MenuBottom from "@/components/MenuBottomCat";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterCat";

  export default {
    name: 'PagePoliticaCookiesCat',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
      /* Retirar el consentiment ha de ser tan facil com donar-lo (art. 7.3
         RGPD). Esborrem les galetes d'analisi, oblidem la decisio i recarreguem:
         el baner torna a sortir i no es carrega res fins que l'usuari decideixi
         de nou. */
      volverAPreguntar() {
        consentimiento.aplicar(false, false);
        consentimiento.olvidar();
        window.location.reload();
      }
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom
    }
  }
</script>
